import Axios from './axios'
/**
 * @interface loginParams -登录参数
 * @property {string} loginName -用户名
 * @property {string} password -用户密码
 */
// 封装User类型的接口方法
export class EditorService {
  /**
   * @description 查询User的信息
   * @param {number} teamId - 所要查询的团队ID
   * @return {HttpResponse} result
   */
  // eslint-disable-next-line require-await
  static async save(params: any) {
    return Axios('/user/ppt/save/', {
      method: 'post',
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
      transformRequest: [(data) => {
        data = JSON.stringify(data)
        return data
      }],
      data: {
        ...params
      },
    })
  }
  // eslint-disable-next-line require-await
  static async teamSave(params: any) {
    return Axios('/space/ppt/save/', {
      method: 'post',
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
      },
      transformRequest: [(data) => {
        data = JSON.stringify(data)
        return data
      }],
      data: {
        ...params
      },
    })
  }
  // eslint-disable-next-line require-await
  static async materialDelete(data: any) {
    return Axios('/user/material/delete/', {
      method: 'post',
      data
    })
  }
  // 背景列表
  // eslint-disable-next-line require-await
  static async getBackgroundList(data: any) {
    return Axios('/material/beijing_list/', {
      method: 'post',
      data,
    })
  }
  // 字体列表
  // eslint-disable-next-line require-await
  static async getWordList(data: any) {
    return Axios('/material/word_list/', {
      method: 'post',
      data,
    })
  }
  // 字体库列表
  // eslint-disable-next-line require-await
  static async getFontList(data: any) {
    return Axios('/font/list/', {
      method: 'post',
      data,
    })
  }
  // 字体分类列表
  // eslint-disable-next-line require-await
  static async getWordCategoryList(data: any) {
    return Axios('/material/word_category_list/', {
      method: 'post',
      data,
    })
  }
  // 图片列表
  // eslint-disable-next-line require-await
  static async getImagesList(data: any) {
    return Axios('/material/image_list/', {
      method: 'post',
      data,
    })
  }
  // 图片分类列表
  // eslint-disable-next-line require-await
  static async getImagesCategoryList(data: any) {
    return Axios('/material/image_category_list/', {
      method: 'post',
      data,
    })
  }
  // 场景列表
  // eslint-disable-next-line require-await
  static async getScenesList(data: any) {
    return Axios('/ppt_template/scene_list/', {
      method: 'post',
      data,
    })
  }
  // 场景列表
  // eslint-disable-next-line require-await
  static async getScenesDetail(id: any) {
    return Axios('/ppt_template/scene-detail-' + id + '/', {
      method: 'post',
    })
  }
  // 模板列表
  // eslint-disable-next-line require-await
  static async getTemplatesList(data: any) {
    return Axios('/ppt_template/list/', {
      method: 'post',
      data,
    })
  }
  // 模板列表
  // eslint-disable-next-line require-await
  static async getTemplatesDetail(id: any) {
    return Axios('/ppt_template/detail-' + id, {
      method: 'post'
    })
  }
  // 模板分类列表
  // eslint-disable-next-line require-await
  static async getTemplatesCategoryList(data: any) {
    return Axios('/ppt_template/category_list/', {
      method: 'post',
      data,
    })
  }
  // 素材分类列表
  // eslint-disable-next-line require-await
  static async getMaterialCategoryList(data: any) {
    return Axios('/material/material_category_list/', {
      method: 'post',
      data,
    })
  }
  // 素材分类列表
  // eslint-disable-next-line require-await
  static async getMaterialList(data: any) {
    return Axios('/material/material_list/', {
      method: 'post',
      data,
    })
  }
  // 素材其他列表
  // eslint-disable-next-line require-await
  static async getMaterialOtherList(data: any) {
    return Axios('/material/other_list/', {
      method: 'post',
      data,
    })
  }
  // 素材其他列表
  // eslint-disable-next-line require-await
  static async getMaterialOtherCategoryList(data: any) {
    return Axios('/material/other_category_list/', {
      method: 'post',
      data,
    })
  }
  // 素材其他列表
  // eslint-disable-next-line require-await
  static async addMaterial(data: any) {
    return Axios('/user/material/click-add/', {
      method: 'post',
      data,
    })
  }
  
}
